import { WishlistLineItem } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Button, ProductDetailsContext } from '@components';
import { useWishlist } from '@hooks';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { colors } from '@themes/colors';
import { t } from '@translations';
import { useContext } from 'react';

export const ProductAddToWishlist = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const { code = '', name } = product;
  const { addToWishlistHandler, removeFromWishlistHandler, wishlist, addResponse, removeResponse } =
    useWishlist();
  const isInWishlist = wishlist?.some(
    (wishlistItem: WishlistLineItem) => wishlistItem.code === code
  );

  return (
    <Button
      variant='text'
      sx={{ background: '#fff', color: '#000', height: '44px' }}
      onClick={
        isInWishlist
          ? () => removeFromWishlistHandler(code, name)
          : () => addToWishlistHandler(code, name)
      }
      disabled={removeResponse.isLoading && addResponse.isLoading}
      startIcon={
        isInWishlist ? (
          <StarIcon sx={{ fontSize: 32, color: colors.primary.mainGreen }} />
        ) : (
          <StarOutlineIcon sx={{ fontSize: 32, color: colors.primary.mainGreen }} />
        )
      }
    >
      {t(TextCodes.Product.Details.AddToWishlist)}
    </Button>
  );
};
